/** Skeleton class with visible contrast in both light and dark mode */
export const sk = 'animate-pulse rounded-md bg-muted-foreground/10';
